import AppSource from '../../data/app-source';
import {
  createItemSurahTemplate,
  createContentFailedTemplate,
  createLoadingTemplate,
  createBookmarkItemTemplate,
} from '../templates/template-creator';

class Home extends HTMLElement {
  connectedCallback() {
    this.render();
    this._insertData();
    this._handlerInstallApp();
    this._handlerDarkMode();
  }

  render() {
    this.innerHTML = `
      <section class="w-11/12 py-8 mb-6 md:mb-8 m-auto">
        <div class="section-title-container">
          <h2 class="section-title" tabindex="0">Al-Quran Mahabbah</h2>
          <p class="section-subtitle" tabindex="0">
            Al-Quran digital Indonesia lengkap disertai dengan terjemahan, tafsir, audio murottal
          </p>
          <button id="install-app" class="animate-bounce w-48 text-lg text-white rounded-full block mx-auto my-8 bg-[#35A29F]">
            Instal Aplikasi
          </button>
        </div>
        <article id="bookmark-container"></article>
        <article class="mb-2 border-b pt-4 pb-12">
          <h3 class="text-xl text-center font-bold underline mb-3">Rekomendasi</h3>
          <article class="flex flex-wrap md:justify-center">
            <a href="#/surah/18" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Al-Kahf</a>
            <a href="#/surah/36" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Yasin</a>
            <a href="#/surah/55" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Ar-Rahman</a>
            <a href="#/surah/56" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Al-Waqi'ah</a>
            <a href="#/surah/67" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Al-Mulk</a>
            <a href="#/surah/112" class="recommend-surah rounded-full text-lg shadow-md text-[#35A29F] hover:duration-300 hover:bg-[#35A29F] hover:text-white px-6 py-2 m-1" tabindex="0">Al-Ikhlas</a>
          </article>
        </article>
        <section class="pt-4">
          <h3 class="text-xl text-center font-bold underline mb-3">Daftar Surah</h3>
          <article id="container-surahs" class="section-body-container"></article>
        </section>
      </section>
    `;
  }

  async _insertData() {
    this.innerHTML += createLoadingTemplate();
    const surahs = await AppSource.getSurahs();
    const containerSurahs = this.querySelector('#container-surahs');
    if (!surahs.error) {
      this._insertDataSurah(surahs, containerSurahs);
      this._insertDataBookmark();
    } else {
      containerSurahs.innerHTML = createContentFailedTemplate();
    }
    this.lastElementChild.remove();
  }

  _insertDataBookmark() {
    const bookmarkContainer = this.querySelector('#bookmark-container');
    const bookmark = JSON.parse(localStorage.getItem('BOOKMARK'));
    if (bookmark) {
      bookmarkContainer.innerHTML = createBookmarkItemTemplate(bookmark);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  _insertDataSurah(surahs, containerSurahs) {
    surahs.data.forEach((surah) => {
      surah.id = surah.number;
      containerSurahs.innerHTML += createItemSurahTemplate(surah);
    });
  }

  _handlerInstallApp() {
    const installApp = this.querySelector('#install-app');
    let deferredPrompt;
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      deferredPrompt = event;
      installApp.classList.remove('hidden');
    });
    installApp.addEventListener('click', async () => {
      if (deferredPrompt !== undefined) {
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          deferredPrompt = undefined;
          installApp.classList.add('hidden');
        }
      }
    });
    if (deferredPrompt === undefined) {
      installApp.classList.add('hidden');
    }
  }

  _handlerDarkMode() {
    const toogleBtnMode = document.querySelector('#toogle-btn-mode');
    const recommendSurah = this.querySelectorAll('.recommend-surah');
    const mode = localStorage.getItem('MODE');
    recommendSurah.forEach((surah) => {
      if (mode && mode === 'dark') {
        surah.classList.add('shadow-white');
      } else {
        surah.classList.remove('shadow-white');
      }
      toogleBtnMode.addEventListener('click', () => {
        surah.classList.toggle('shadow-white');
      });
    });
  }
}

customElements.define('home-page', Home);
const home = '<home-page></home-page>';
export default home;
